
<h3 class="mt-3">Informações relevantes</h3>
<div class="mb-5" [formGroup]="formInformationRelevation">
	<div class="d-flex flex-row flex-wrap mb-3 mt-5 justify-content-between">

	 	<div class="input-group col-4 flex-column" formGroupName="productivity">
			<label for="productivity-input" class="mb-2">{{ 'labelProdutivity' | translate }}</label>
			<div class="d-inline-flex flex-row">
		    <div class="input-values">
		    	<input id="productivity-input" type="text" class="form-control rounded input-values" formControlName="value">
		    </div>
				<div [style.background-color]="backgroundColorProductivity" class="input-group-prepend col ml-2 border rounded align-items-center">
		      <span>{{ formInformationRelevation.controls.productivity.get('label').value | translate }}</span>
		    </div>
			</div>
	  </div>

	 	<div class="input-group col-4 flex-column" formGroupName="financial">
			<label for="financial-input" class="mb-2">{{ 'labelFinancial' | translate }}</label>
			<div class="d-inline-flex flex-row">
		  	<div class="input-values">
		    	<input id="financial-input" type="text" class="form-control rounded input-values" formControlName="value"  mask="separator.2"  [prefix]="'R$ '" thousandSeparator="." decimalMarker=",">
		   	</div>
		    <div [style.background-color]="backgroundColorFinancial" class="input-group-prepend border rounded col ml-2 align-items-center">
		   	  <span>{{ formInformationRelevation.controls.financial.get('label').value | translate }}</span>
		    </div>
			</div>
	  </div>

	 	<div class="input-group col-4 flex-column" formGroupName="sustainability">
			<label for="sustainability-input" class="mb-2">{{ 'labelSustentability' | translate }}</label>
			<div class="d-inline-flex flex-row">
		  	<div class="input-values">
		   		<input id="sustainability-input" type="text" class="form-control rounded input-values" formControlName="value">
		   	</div>
				<div [style.background-color]="backgroundColorSustainability" class="input-group-prepend col  ml-2 border rounded align-items-center">
					<span>{{ formInformationRelevation.controls.sustainability.get('label').value | translate }}</span>
		    </div>
			</div>
	  </div>
	</div>
  <div class="border border-primary rounded">
   	<div formArrayName="indicators">
    	<div *ngFor="let item of indicatorsArray.controls; let i = index" [formGroupName]="i" class="d-flex flex-row align-items-center justify-content-center flex-wrap mb-3 mx-5 mt-2">
	   		<button  type="button" data-toggle="tooltip" data-placement="top" title="{{ 'aproveIdeaModal.changedAuthor' | translate }}">
	         <svg-icon class="is-cursor" src="assets/svg/close-indicator.svg" (click)="removeIndicator(i)" class="align-items-center mt-4 mr-3"></svg-icon>
	      </button>
    		<div class="form-group input-indicators">
          <label>Indicador</label>
          <select class="form-control rounded" id="indicators" formControlName="selectedIndicator">
         		<option *ngFor="let option of item.get('indicators').value" [value]="option">
              {{ option | translate }}
            </option>
          </select>
        </div>

        <div class="form-group ml-2 input-indicators">
	        <label>Quantidade</label>
	        <input type="text" class="form-control rounded" formControlName="quantity">
        </div>

        <div class="form-group ml-2 input-indicators">
	        <label>Unidade</label>
	        <select class="form-control rounded" id="indicators" formControlName="selectedUnidade">
         		<option *ngFor="let option of item.get('unidades').value" [value]="option">
              {{ option }}
            </option>
          </select>
        </div>

        <div class="form-group ml-2 input-indicators">
	        <label>Pontuação</label>
					<div id="customDiv" class="form-control d-flex rounded align-items-center justify-content-start">
				  	{{ formInformationRelevation.controls.indicators.at(i).get('pontuation').value }}
				  </div>
        </div>
    	</div>
    </div>
  </div>
  <div class="d-flex justify-content-center mt-4">
  	<button type="button" (click)="addFormIndicator()" class="btn btn-primary">Adicionar Indicador</button>
  </div>

  <div class="d-flex flex-row mt-4">
 		<div class="form-group ml-2 input-indicators">
      <label>Data de Premiação</label>
      <div id="customDiv" class="form-control d-flex rounded align-items-center justify-content-start">
		  	{{ formInformationRelevation.controls.dataPremiation.value }}
		  </div>
   	</div>

    <div class="form-group ml-2 input-indicators">
      <label>Total de pontuação</label>
      <div id="customDiv" class="form-control d-flex rounded align-items-center justify-content-start">
		  	{{ formInformationRelevation.controls.pontuationTotal.value }}
		  </div>
   	</div>

    <div class="form-group ml-2 input-indicators">
      <label>Quantidade de Autores</label>
      <div id="customDiv" class="form-control d-flex rounded align-items-center justify-content-start">
		  	{{ formInformationRelevation.controls.quantityAuthors.value }}
		  </div>
   	</div>

    <div class="form-group ml-2 input-indicators">
      <label>Prêmio Por Colaborador</label>
      <div id="customDiv" class="form-control d-flex rounded align-items-center justify-content-start">
		  	{{ formInformationRelevation.controls.premiationColaboration.value | currency: 'BRL':'symbol':'1.2-2':'pt-BR' }}
		  </div>
   	</div>

    <div class="form-group ml-2 input-indicators">
      <label>Prêmio da Idea</label>
      <div id="customDiv" class="form-control d-flex rounded align-items-center justify-content-start">
		  	{{ formInformationRelevation.controls.premioIdea.value | currency: 'BRL':'symbol':'1.2-2':'pt-BR' }}
		  </div>
   	</div>
  </div>
</div>


<app-upload-file></app-upload-file>
